import { render, staticRenderFns } from "./DataStatistics.vue?vue&type=template&id=15ee8e96&scoped=true"
import script from "./DataStatistics.vue?vue&type=script&lang=js"
export * from "./DataStatistics.vue?vue&type=script&lang=js"
import style0 from "./DataStatistics.vue?vue&type=style&index=0&id=15ee8e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ee8e96",
  null
  
)

export default component.exports